// components/layout/Navbar.jsx
import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <a href="/" className="logo">
          <img src="assets/logo.png" alt="tas logo" className="logo-image" />
        </a>
        <div className="nav-links">
          <a href="/login" className="nav-link login-btn">Login</a>
          <a href="/register" className="nav-link register-btn">Register</a>
        </div>
      </div> 
    </nav>
  );
};

export default Navbar;